var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 15.9997L8.66683 22.6663V17.6663H23.6668V14.333H8.66683V9.33301L0.333496 15.9997Z",
    fill: "#FD1B2A",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6687 0.998104C16.6979 0.99264 14.7456 1.37829 12.9249 2.13271C11.1042 2.88713 9.45135 3.99533 8.06201 5.3931L10.4187 7.74977C12.622 5.54644 15.552 4.33144 18.6687 4.33144C21.7853 4.33144 24.7153 5.54644 26.9187 7.74977C29.122 9.9531 30.337 12.8831 30.337 15.9998C30.337 19.1164 29.122 22.0464 26.9187 24.2498C24.7153 26.4531 21.7853 27.6681 18.6687 27.6681C15.552 27.6681 12.622 26.4531 10.4187 24.2498L8.06201 26.6064C10.8937 29.4398 14.6603 31.0014 18.6687 31.0014C22.677 31.0014 26.4437 29.4398 29.2753 26.6064C32.1087 23.7748 33.6703 20.0081 33.6703 15.9998C33.6703 11.9914 32.1087 8.22477 29.2753 5.3931C27.886 3.99533 26.2331 2.88713 24.4124 2.13271C22.5918 1.37829 20.6395 0.99264 18.6687 0.998104Z",
    fill: "#FD1B2A",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutRed);
export default __webpack_public_path__ + "static/media/logout_red.7f4f2dc74ec3d7fdec83f964f951ba11.svg";
export { ForwardRef as ReactComponent };